import { useEffect, useState } from 'react';
import { Subject } from '../types';

/** Hook to keep track of a @see Subject's value as it changes. */
export function useSubject<TSubject, TInitial = TSubject>(
  subject: Subject<TSubject>,
  initialValue: TInitial
): TSubject | TInitial {
  const [value, setStateValue] = useState<TSubject | TInitial>(() => initialValue);

  useEffect(() => {
    let cancelled = false;
    const setValue = (newValue: TSubject) => {
      // Wait for synchronous code to run before setting the new value.
      // This prevents state issues like removing global modals before setting their state.
      requestAnimationFrame(() => {
        if (!cancelled) {
          setStateValue(() => newValue);
        }
      });
    };

    subject.subscribe(setValue);
    return () => {
      subject.unsubscribe(setValue);
      cancelled = true;
    };
  }, [subject]);

  return value;
}
